import React, { useState } from "react";

import YourInfos from "./YourInfos";
import { IUser } from "../interfaces/user";

export interface UserType {
  id: string;
  titleId?: string;
  firstname: string;
  lastname: string;
  email: string;
  phoneNumber: string;
  image?: File;
}

const ProfileComponent = ({ user, id }: { user: IUser; id: string }) => {
  const [userInfos, setUserInfos] = useState<UserType>({
    id: id,
    titleId: user.titleId,
    firstname: user.firstname,
    lastname: user.lastname,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const handleChangeUserInfos = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setUserInfos({ ...userInfos, [event.target.name]: event.target.value });
  };

  const handleChangeImage = (image: File) => {
    setUserInfos({ ...userInfos, image });
  };

  return (
    <div>
      <YourInfos
        userInfos={userInfos}
        handleChangeUserInfos={handleChangeUserInfos}
        handleChangeImage={handleChangeImage}
      />
    </div>
  );
};
export default ProfileComponent;
